export default __webpack_public_path__ + "static/media/header.1e6c8024.gif";